import {
  LOAD_ORDER_FAILURE,
  LOAD_ORDER_REQUEST,
  LOAD_ORDER_SUCCESS,
} from 'dux/checkoutOrder/actionTypes';
import { CLEAR_CHECKOUT } from 'dux/checkout/actionTypes';
import { apiReducer, initialApiState } from 'utils/reduxUtils';

export const order = (state = initialApiState, action) => {
  switch (action.type) {
    case CLEAR_CHECKOUT:
      return initialApiState;
    default:
      return apiReducer(
        [LOAD_ORDER_REQUEST, LOAD_ORDER_SUCCESS, LOAD_ORDER_FAILURE],
        state,
        action
      );
  }
};
